module.exports = __webpack_public_path__ + "static/media/layer-unilever.7dd7ac94.png";